export interface HudOptions {
  statusText(): string | null;
  onUndo(): void;
  onNewGame(): void;
  onHint(): void;
  onReplay(): void;
}

export interface Hud {
  recordMove(): void;
  recordRemoval(count?: number): void;
  resetStats(total: number): void;
  refreshStatus(): void;
  setUndoEnabled(enabled: boolean): void;
  setHintEnabled(enabled: boolean): void;
  showWin(): void;
  showLose(): void;
  hideWin(): void;
}

export function createHud(opts: HudOptions): Hud {
  const movesEl = document.getElementById('moves')!;
  const remainingEl = document.getElementById('remaining')!;
  const timeEl = document.getElementById('time')!;
  const statusEl = document.getElementById('status')!;
  const winOverlay = document.getElementById('win-overlay')!;
  const winMovesEl = document.getElementById('win-moves')!;
  const winTimeEl = document.getElementById('win-time')!;
  const winTitleEl = document.getElementById('win-title');
  const undoBtn = document.getElementById('undo') as HTMLButtonElement | null;
  const hintBtn = document.getElementById('hint') as HTMLButtonElement | null;

  let movesCount = 0;
  let remaining = 0;
  let startedAt = 0;
  let timerStarted = false;

  function tickClock() {
    movesEl.textContent = `${movesCount} ${movesCount === 1 ? 'pair' : 'pairs'}`;
    remainingEl.textContent = `${remaining} left`;
    const sec = timerStarted ? Math.floor((performance.now() - startedAt) / 1000) : 0;
    const mm = Math.floor(sec / 60);
    const ss = sec % 60;
    timeEl.textContent = `${mm}:${ss.toString().padStart(2, '0')}`;
  }
  setInterval(tickClock, 250);
  tickClock();

  document.getElementById('new-game')?.addEventListener('click', () => opts.onNewGame());
  document.getElementById('win-replay')?.addEventListener('click', () => opts.onReplay());
  undoBtn?.addEventListener('click', () => opts.onUndo());
  hintBtn?.addEventListener('click', () => opts.onHint());
  window.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'z' && !e.shiftKey) {
      e.preventDefault();
      opts.onUndo();
    } else if (e.key.toLowerCase() === 'h' && !e.metaKey && !e.ctrlKey) {
      opts.onHint();
    }
  });

  const hud: Hud = {
    recordMove() {
      movesCount++;
      if (!timerStarted) {
        timerStarted = true;
        startedAt = performance.now();
      }
      tickClock();
    },
    recordRemoval(count = 2) {
      remaining = Math.max(0, remaining - count);
      tickClock();
    },
    resetStats(total) {
      movesCount = 0;
      remaining = total;
      timerStarted = false;
      startedAt = 0;
      statusEl.classList.remove('show');
      hud.hideWin();
      tickClock();
    },
    refreshStatus() {
      const text = opts.statusText();
      if (text) {
        statusEl.textContent = text;
        statusEl.classList.add('show');
      } else {
        statusEl.classList.remove('show');
      }
    },
    setUndoEnabled(enabled) {
      if (undoBtn) undoBtn.disabled = !enabled;
    },
    setHintEnabled(enabled) {
      if (hintBtn) hintBtn.disabled = !enabled;
    },
    showWin() {
      if (winTitleEl) winTitleEl.textContent = 'You won';
      winMovesEl.textContent = String(movesCount);
      winTimeEl.textContent = timeEl.textContent ?? '0:00';
      winOverlay.classList.remove('win-overlay--lose');
      winOverlay.hidden = false;
    },
    showLose() {
      if (winTitleEl) winTitleEl.textContent = 'No moves left';
      winMovesEl.textContent = String(movesCount);
      winTimeEl.textContent = timeEl.textContent ?? '0:00';
      winOverlay.classList.add('win-overlay--lose');
      winOverlay.hidden = false;
    },
    hideWin() {
      winOverlay.classList.remove('win-overlay--lose');
      winOverlay.hidden = true;
    },
  };
  return hud;
}
